import { Injectable, Inject } from '@angular/core';
import { MonitoredTrain } from '../models/monitored-train';

@Injectable({
  providedIn: 'root'
})
export class PreprocessingMonitoredTrainService {

  constructor(
    @Inject('ZabbixOverviewFactory') private zabbixOverviewFactory: any,
  ) { }

  trainList = (trains: any[]) => {
        return trains.map(train => {
          return this.singleTrain(train);
      })
  }

  singleTrain = (train: any) => {
    train.uid = `${train.projectId}-${train.trainId}`;
    train.structure = train.structure || train.trainStructure;
    train.type = train.trainType;
    train.displayTypeName = (train.trainConfiguration && train.trainConfiguration.displayTypeName) || train.trainType;
    train.checkedLabel = train.checkedLabel && train.checkedLabel.replace('label', 'badge'); 
    const simAlarmObj = {
      level: 0,
      count: 0,
      labelClassForAlarm: ''
    };
    if (train.alarms) {
      train.alarms.forEach((simAlarm: any) => {
        if (simAlarm.type === 'sim-usage-alarm'){
          if(simAlarm.level > simAlarmObj.level) {
          simAlarmObj.level = simAlarm.level;
        }
        simAlarmObj.count++;
      }});
      train.simAlarm = simAlarmObj;
    }

    if (train.structure) {
      const proxyUpDate = this.zabbixOverviewFactory.adjustOfflineProxyPriorities([train.structure]);
      const structureData = this.zabbixOverviewFactory.makeStructure(proxyUpDate);
      const orderedData = this.zabbixOverviewFactory.orderData(structureData);
      const hashStructure = this.zabbixOverviewFactory.fillHashCodes(orderedData);
      const priorityStructure = this.zabbixOverviewFactory.fillPriorities(hashStructure);
      const newStructure = this.zabbixOverviewFactory.calculateCoachSeverity(priorityStructure);
      train.structure = newStructure[0];
    }
    // delete train.trainStructure;

    if (train.currentTrip) {
      const fullTime = train.currentTrip.endDate - train.currentTrip.startDate;
      const elapsed = new Date().getTime() - train.currentTrip.startDate;
      const percent = elapsed / fullTime * 100;
      train.currentTrip.percent = percent <= 100 ? percent : '100';
      train.currentTrip.trajectory = `${train.currentTrip.startStation} - ${train.currentTrip.endStation}`;
    }

    if (train.nextTrip) {
      train.nextTrip.trajectory = `${train.nextTrip.startStation} - ${train.nextTrip.endStation}`;
      train.nextTrip.remainingTimeToStart = - (train.nextTrip.startDate - new Date().getTime());
    }
    //mbits
    let totalUp = 0;
    let totalDown = 0;
    if (train.links) {
      train.links.forEach(function (linkInfo) {
        totalDown += linkInfo.downloadRate;
        totalUp += linkInfo.uploadRate;
      });
    }

    return Object.assign({}, train, {
      totalDownloadRate: totalDown,
      totalUploadRate: totalUp,
      totalDownloadRateKbit: totalDown * 1000,
      totalUploadRateKbit: totalUp * 1000,
      issues: train.issues && train.issues.map(issue => {
        if (issue.type === 'ZABBIX_ALARM') {
          issue.type = 'zabbix-alarm';
        }
        if (issue.type === 'NMS_ALARM') {
          issue.type = 'noc-alarm';
        }
        return issue;
      }) || []
    });
  }

}
